import EditDialog from "@/components/common/EditDialog";
import type {
    ExtendedEventViewT,
    ExtendedShockwaveViewT,
} from "@/types/database/events";
import ShockwaveDetailsForm from "./ShockwaveDetailsForm";
import ShockwaveDetailsList from "./ShockwaveDetailsList";
import ShockwaveForm from "./ShockwaveForm";
import ShockwaveMainInfo from "./ShockwaveMainInfo";

interface Props {
    diaryId: string;
    trackerId?: string;
    eventId: string;
    organisationId: string;
    shockwave: ExtendedShockwaveViewT;
    event: ExtendedEventViewT;
    editable: boolean;
}

const ShockwaveItem = (props: Props) => {
    const { shockwave, editable, diaryId, eventId, organisationId } = props;

    return (
        <>
            <EditDialog
                label="Shockwave Therapy"
                info={<ShockwaveMainInfo shockwave={shockwave} />}
                editable={editable}
            >
                <ShockwaveForm
                    shockwave={shockwave}
                    shockwaveId={shockwave.shockwave_id}
                    diaryId={diaryId}
                    eventId={eventId}
                    organisationId={organisationId}
                    isDialog={true}
                />
            </EditDialog>

            <EditDialog
                label="Shockwave Details"
                info={
                    <ShockwaveDetailsList
                        shockwaveDetails={shockwave.shockwave_details ?? []}
                    />
                }
                editable={editable}
            >
                <ShockwaveDetailsForm
                    shockwave={shockwave}
                    diaryId={diaryId}
                    shockwaveId={shockwave.shockwave_id}
                    eventId={eventId}
                    isDialog={true}
                />
            </EditDialog>
        </>
    );
};

export default ShockwaveItem;
